import React from "react";
import { ChevronLeft, ChevronRight, Calendar } from "lucide-react";

const MonthPicker = ({ selectedMonth, setSelectedMonth }) => {
  const currentMonth = new Date().toISOString().slice(0, 7);

  const handlePrevMonth = () => {
    const prevMonth = new Date(selectedMonth + "-01");
    prevMonth.setMonth(prevMonth.getMonth() - 1);
    setSelectedMonth(prevMonth.toISOString().slice(0, 7));
  };

  const handleNextMonth = () => {
    const nextMonth = new Date(selectedMonth + "-01");
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    const nextMonthStr = nextMonth.toISOString().slice(0, 7);

    if (nextMonthStr <= currentMonth) {
      setSelectedMonth(nextMonthStr);
    }
  };

  const formatMonthYear = (date) => {
    return new Date(date + "-01").toLocaleString("default", {
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className="flex items-center space-x-3 bg-white px-3 py-2 rounded-lg shadow-md">
      <button onClick={handlePrevMonth} className="p-1">
        <ChevronLeft className="w-5 h-5 text-gray-500" />
      </button>
      <div className="flex items-center space-x-2">
        <Calendar className="w-5 h-5 text-gray-500" />
        <span className="text-lg font-medium">{formatMonthYear(selectedMonth)}</span>
      </div>
      <button 
        onClick={handleNextMonth} 
        className="p-1"
        disabled={selectedMonth >= currentMonth}
      >
        <ChevronRight className={`w-5 h-5 ${selectedMonth >= currentMonth ? "text-gray-300" : "text-gray-500"}`} />
      </button>
    </div>
  );
};


export default MonthPicker;